import { ISortBy, ISortOption } from 'commerce/factFinder/queryParameters';

export interface FactFinderProductResponse {
  foundWords: string[];
  id: string;
  masterValues: {
    comparisonPrice: string;
    longDescription: string;
    dailyDealPosition: string;
    colors: string;
    ratingScore: string;
    categoryNames: string;
    comparisonPriceLabel: string;
    seoUrl: string;
    ean: string;
    price: string;
    imageUrl: string;
    headline: string;
    brand: string;
    referenceKey: string;
    types: string;
    articleId: string;
    length: string;
    tax: string;
    priceValue: number;
    genders: string;
    collection: string;
    shortDescription: string;
    productReleaseDate: string;
    ratingCount: string;
    tags: string;
    categoryIds: string;
    materials: string;
    dailyDeal: string;
    bestseller: string;
    category: string;
    productReferenceKey: string;
    seoURLs: string;
  };
  position: number;
  score: number;
  variantValues: {
    referenceKey?: string;
  };
}

export interface FactFinderApiResponse {
  hits?: FactFinderProductResponse[];
  totalHits?: number;
  facets?: FactFinderFacet[];
  sortItems?: ISortOption[];
  paging?: {
    currentPage: number;
    pageCount: number;
  };
  filters?: IFilterParam[];
  suggestions?: { attributes: { Url: string } }[];
}

export interface IFilter {
  type?: string;
  value?: string | (string | number)[];
  displayValue?: string;
}

export type FilterClient = {
  [Facets.TITLE]?: string;
  [Facets.BRAND]?: string[];
  [Facets.PRICE]?: number[];
  [Facets.COLORS]?: string[];
  [Facets.CATEGORY_NAMES]?: string;
  [Facets.SIZE]?: string[];
  [Facets.MATERIALS]?: string[];
  [Facets.RATING]?: number[];
  [Facets.GENDERS]?: string[];
  [Facets.TYPES]?: string[];
  [Facets.TAGS]?: string[];
};

export enum Facets {
  BRAND = 'brand',
  CATEGORY = 'category',
  CATEGORY_NAMES = 'categoryNames',
  PRICE = 'priceValue',
  COLORS = 'colors',
  TITLE = 'headline',
  SIZE = 'size',
  MATERIALS = 'materials',
  RATING = 'ratingScore',
  GENDERS = 'genders',
  TYPES = 'types',
  TAGS = 'tags',
}

interface FactFinderFacetElement {
  text: string;
  totalHits: number;
  searchParams: {
    filters: IFilterParam[];
  };
}

export interface IFilterParam {
  name: string;
  multiplyValues?: {
    value: string[] | string;
  };
  values?: {
    type: 'or' | 'and';
    value: string;
    exclude: boolean;
  }[];
}

export interface FactFinderFacetElementPrice extends FactFinderFacetElement {
  absoluteMaxValue: number;
  absoluteMinValue: number;
}

export interface FactFinderFacet {
  type: string;
  name: string;
  associatedFieldName: Facets;
  elements: (FactFinderFacetElement | FactFinderFacetElementPrice)[];
  unit: string;
}

export interface FactFinderSuggestions {
  name: string;
  image: string;
  score: number;
  attributes: {
    ArticleNumber: string;
    MasterArticleNumber: string;
    PriceValue: number;
    Url?: string;
    keywords?: string;
  };
}

export interface GetFFProductsParams {
  perPage?: number;
  page?: number;
  categoryName?: string;
  sortBy?: ISortBy;
  query?: string;
  filters?: FilterClient;
  searchQuery?: URLSearchParams;
}
